import axios from 'axios';

import { apiUrl } from '../apiUrl';

export const decodeWorkshop = async ({ slug }) => {
  try {
    const queryUrl = `${apiUrl}/decode/${slug}`;
    const response = await axios.get(queryUrl);

    return response.data || [];
  } catch (error) {
    console.log('failed decoding');

    return [];
  }
};
